import Tabs from 'components/tabs'
import Budget from './budget'
import Family from './family'
import LabeledFamily from './labeled-family'
import intl from 'react-intl-universal'
import { BudgetFamilyProvider } from './context'

const BudgetFamily = () => {
  const budgetFamilyContent = [
    {
      key: 1,
      label: intl.get('master-data.walletsAndFamilys.wallets.header.title'),
      content: <Budget />
    },
    {
      key: 2,
      label: intl.get('master-data.walletsAndFamilys.familys.header.title'),
      content: <Family />
    },
    {
      key: 3,
      label: intl.get('master-data.walletsAndFamilys.labeledFamily.header.title'),
      content: <LabeledFamily />
    }
  ];

  return (
    <BudgetFamilyProvider>
      <Tabs 
        selected={3}
        tabsContent={budgetFamilyContent}
      />
    </BudgetFamilyProvider>
  );
}

export default BudgetFamily;
